export interface BibleVersion {
  id: string;
  name: string;
  fullName: string;
  language: string;
  year?: number;
  license: string;
  available: boolean;
}

// Currently available versions through bible-api.com
export const bibleVersions: BibleVersion[] = [
  {
    id: 'kjv',
    name: 'KJV',
    fullName: 'King James Version',
    language: 'en',
    year: 1611,
    license: 'Public Domain',
    available: true
  },
  {
    id: 'web',
    name: 'WEB',
    fullName: 'World English Bible',
    language: 'en',
    license: 'Public Domain',
    available: true
  },
  {
    id: 'asv',
    name: 'ASV',
    fullName: 'American Standard Version',
    language: 'en',
    year: 1901,
    license: 'Public Domain',
    available: true
  },
  // These versions will be available once we integrate with Bible Gateway API
  {
    id: 'niv',
    name: 'NIV',
    fullName: 'New International Version',
    language: 'en',
    year: 2011,
    license: 'Copyright Biblica',
    available: false
  },
  {
    id: 'esv',
    name: 'ESV',
    fullName: 'English Standard Version',
    language: 'en',
    year: 2016,
    license: 'Copyright Crossway',
    available: false
  },
  {
    id: 'nlt',
    name: 'NLT',
    fullName: 'New Living Translation',
    language: 'en',
    year: 2015,
    license: 'Copyright Tyndale House Foundation',
    available: false
  }
];